<template>
  <v-checkbox v-if="useVuetify" v-bind="$attrs" :model-value="modelValue" @update:modelValue="$emit('update:modelValue', $event)">
    <slot></slot>
  </v-checkbox>
  <input type="checkbox" v-else :checked="modelValue" @input="$emit('update:modelValue', !modelValue)" v-bind="$attrs"/>
</template>
<script setup>
import { inject } from 'vue';

defineOptions({
  inheritAttrs: false
})

const emit = defineEmits(['update:modelValue'])
defineProps({
  modelValue: Boolean
})
const useVuetify = inject("useVuetify",false);
</script>